module.exports = require("./fr-GQ.d.ts");